// src/components/Home/ActivityFeed.jsx
import React from "react";

const ActivityFeed = ({ activities }) => {
  if (!activities || activities.length === 0) {
    return (
      <div className="dashboard-widget">
        <h3>Atividades Recentes</h3>
        <p style={{ color: "#95a5a6", textAlign: "center", padding: "20px" }}>
          Não tem atividades recentes.
        </p>
      </div>
    );
  }

  const getActivityIcon = (type) => {
    switch (type) {
      case "lead_created":
        return "👤";
      case "automation_executed":
        return "⚡";
      case "message_sent":
        return "💬";
      default:
        return "📌";
    }
  };

  const getActivityColor = (type) => {
    switch (type) {
      case "lead_created":
        return "#3498db";
      case "automation_executed":
        return "#2ecc71";
      case "message_sent":
        return "#f39c12";
      default:
        return "#95a5a6";
    }
  };

  const formatTimestamp = (timestamp) => {
    if (!timestamp) return "";
    const date = new Date(timestamp);
    const now = new Date();
    const diffMs = now - date;
    const diffMins = Math.floor(diffMs / 60000);

    if (diffMins < 1) return "Just now";
    if (diffMins < 60) return `${diffMins}m ago`;
    if (diffMins < 1440) return `${Math.floor(diffMins / 60)}h ago`;
    return date.toLocaleDateString();
  };

  return (
    <div className="dashboard-widget">
      <h3 style={{ marginBottom: "15px" }}>Atividades Recentes</h3>
      <div style={{ position: "relative" }}>
        <div
          style={{
            position: "absolute",
            left: "15px",
            top: "10px",
            bottom: "10px",
            width: "2px",
            background: "#e9ecef",
          }}
        />

        <div style={{ display: "flex", flexDirection: "column", gap: "15px" }}>
          {activities.map((activity, index) => (
            <div key={index} style={{ position: "relative", paddingLeft: "40px" }}>
              <div
                style={{
                  position: "absolute",
                  left: "8px",
                  top: "4px",
                  width: "16px",
                  height: "16px",
                  borderRadius: "50%",
                  background: getActivityColor(activity.type),
                  border: "3px solid white",
                  zIndex: 1,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "8px",
                }}
              >
                {getActivityIcon(activity.type)}
              </div>

              {/* Activity content */}
              <div
                style={{
                  padding: "10px",
                  background: "var(--bg-tertiary",
                  borderRadius: "6px",
                }}
              >
                <div style={{ fontSize: "14px", marginBottom: "4px" }}>
                  {activity.title}
                </div>
                <div style={{ fontSize: "12px", color: "#95a5a6" }}>
                  {formatTimestamp(activity.timestamp)}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ActivityFeed;
